// src/components/games/dungeon/dungeonUtils.ts

export function longDir(s: string): string {
  return { n: "north", s: "south", e: "east", w: "west", u: "up", d: "down" }[s[0]] || s;
}

export function findMatch(list: string[], term: string): string | null {
  if (!term) return null;
  term = term.toLowerCase();
  for (const i of list) if (i.toLowerCase() === term) return i;
  for (const i of list) if (i.toLowerCase().includes(term)) return i;
  return null;
}

export function removeFromArray(a: string[], i: string): void {
  const x = a.indexOf(i);
  if (x > -1) a.splice(x, 1);
}

export function hasScrolls(inv: string[]): boolean {
  return inv.some(x => x.includes("blank scrolls"));
}

export function removeScrolls(inv: string[]): string[] {
  return inv.filter(x => !x.includes("blank scrolls"));
}